/**
 * Pure rules for the source-account review, kept out of the component so they are testable
 * without a DOM.
 */
import type { ReviewReason, SourceAccountReview } from '../../services/sourceAccounts.service';
import { isMfaCode } from '../../lib/mfaApproval';

/** Mirror the server floors so the button is disabled before the round trip. */
export const MIN_NOTE = 10;
/** With no name from the bank the client's transfer receipt is the evidence: say which one. */
export const MIN_RECEIPT_NOTE = 20;

export function noteFloor(reason: ReviewReason): number {
  return reason === 'no_sender_name' ? MIN_RECEIPT_NOTE : MIN_NOTE;
}

export function reasonLabel(reason: ReviewReason): string {
  return reason === 'no_sender_name'
    ? 'The bank did not report who sent it'
    : 'The name the bank reported is not the client’s';
}

export function noteHint(reason: ReviewReason): string {
  return reason === 'no_sender_name'
    ? 'Name the transfer receipt (the CEP tracking key) that shows the client as the ordering party.'
    : 'Say what you checked: why the two names are the same person, or are not.';
}

export function canDecide(
  review: Pick<SourceAccountReview, 'reason'>,
  note: string,
  mfaCode: string,
): boolean {
  return note.trim().length >= noteFloor(review.reason) && isMfaCode(mfaCode.trim());
}

export function oldestFirst(rows: SourceAccountReview[]): SourceAccountReview[] {
  return [...rows].sort((a, b) => a.posted_at.localeCompare(b.posted_at));
}
